import AutoNumeric from 'autonumeric';
import { trackCtaClicked } from './analyticsTracker.js';

const HANDOFF_PREFIX = '#calcimo-handoff?';
const VALID_AMOUNT = /^\d{1,12}(?:\.\d{1,2})?$/;
const VALID_RATE = /^(?:10\.0|\d\.\d)$/;

export const initInvestmentFunnelHandoff = async () => {
    if (!window.location.hash.startsWith(HANDOFF_PREFIX)) {
        return;
    }

    const parameters = new URLSearchParams(window.location.hash.slice(HANDOFF_PREFIX.length));
    window.history.replaceState(null, '', window.location.pathname + window.location.search);

    const source = parameters.get('source');
    if (!['check-kapitalanlage', 'check-kapital'].includes(source)) {
        return;
    }

    const selection = parameters.get('selection');
    const validSelections = source === 'check-kapital' ? ['budget', 'new'] : ['a', 'b', 'new'];
    if (!validSelections.includes(selection)) {
        return;
    }

    const price = parameters.get('price');
    const rent = parameters.get('rent');
    if (
        source === 'check-kapitalanlage'
        && selection !== 'new'
        && (!VALID_AMOUNT.test(price || '') || !VALID_AMOUNT.test(rent || '') || Number(price) <= 0)
    ) {
        return;
    }
    const interest = parameters.get('interest');
    const repayment = parameters.get('repayment');
    if (
        source === 'check-kapital'
        && selection === 'budget'
        && (!VALID_AMOUNT.test(price || '') || Number(price) <= 0
            || !VALID_RATE.test(interest || '') || !VALID_RATE.test(repayment || ''))
    ) {
        return;
    }

    const form = document.getElementById('quickcheck__form');
    const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;
    if (!form || !csrfToken) {
        return;
    }

    await trackCtaClicked(source === 'check-kapital'
        ? `home_budget_${selection}`
        : `investment_comparison_${selection}`);

    try {
        const response = await fetch('/reset-calculation', {
            method: 'POST',
            headers: {
                Accept: 'application/json',
                'X-CSRF-TOKEN': csrfToken,
            },
        });
        if (!response.ok) {
            return;
        }
    } catch {
        return;
    }

    if (selection === 'new') {
        window.location.reload();

        return;
    }

    if (source === 'check-kapital') {
        try {
            const response = await fetch('/home-funnel-prefill', {
                method: 'POST',
                headers: {
                    Accept: 'application/json',
                    'Content-Type': 'application/json',
                    'X-CSRF-TOKEN': csrfToken,
                },
                body: JSON.stringify({ price, interest, repayment }),
            });
            if (response.ok) {
                window.location.reload();
            }
        } catch {
            return;
        }

        return;
    }

    const priceInput = form?.querySelector('[name="totalPrice"]');
    const rentInput = form?.querySelector('[name="rent"]');
    const capitalInvestment = form?.querySelector('[name="usageType"][value="capitalInvestment"]');
    if (!priceInput || !rentInput || !capitalInvestment) {
        return;
    }

    capitalInvestment.checked = true;
    capitalInvestment.dispatchEvent(new Event('change', { bubbles: true }));

    for (const [input, value] of [[priceInput, price], [rentInput, rent]]) {
        const formatter = AutoNumeric.getAutoNumericElement(input);
        if (formatter) {
            formatter.set(value);
        } else {
            input.value = value;
        }
    }

    form.requestSubmit();
};
